/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Detail_Trace_ButtonInputs */

const vi_product_lot_detail_trace_button = /** @type {(inputs: Product_Lot_Detail_Trace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truy xuất nguồn gốc`)
};

/**

* @param {Product_Lot_Detail_Trace_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_detail_trace_button = /** @type {((inputs?: Product_Lot_Detail_Trace_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Detail_Trace_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_detail_trace_button(inputs)
});